import { CustomFieldValue } from '../../../../../types/custom_field';
import { Product } from '../../../../../types/product';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfProductProperty {
  serial = 'serial',
}

export class PdfProductDataResolver extends PdfEntityDataResolver<Product, PdfProductProperty> {
  entityType: PdfFieldEntity = PdfFieldEntity.product;
  properties = Object.values(PdfProductProperty);

  getCustomFieldByEntity(entity: Product, id: string): CustomFieldValue | undefined {
    throw new Error('Method not implemented.');
  }

  getLabelByProperty(property: PdfProductProperty): string {
    switch (property) {
      case PdfProductProperty.serial:
        return 'Serial Number';
    }
  }

  getValueByProperty(property: PdfProductProperty, entity: Product): string {
    switch (property) {
      case PdfProductProperty.serial:
        return entity.serial || '';
    }
  }
}
